import {COMPANIES_UPDATE} from "../actions/companyActions";

const INITIAL_STATE = {
  companies: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case COMPANIES_UPDATE:
      return {
        ...state,
        companies: action.payload.data,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/company/reducers/CompanyReducer.js